import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CountryService {

  private countries: { label: string, value: string }[] = [
    { label: 'Brasil', value: 'BR' },
    { label: 'Afeganistão', value: 'AF' },
    { label: 'África do Sul', value: 'ZA' },
    { label: 'Albânia', value: 'AL' },
    { label: 'Alemanha', value: 'DE' },
    { label: 'Andorra', value: 'AD' },
    { label: 'Angola', value: 'AO' },
    { label: 'Antígua e Barbuda', value: 'AG' },
    { label: 'Arábia Saudita', value: 'SA' },
    { label: 'Argentina', value: 'AR' },
    { label: 'Armenia', value: 'AM' },
    { label: 'Austrália', value: 'AU' },
    { label: 'Áustria', value: 'AT' },
    { label: 'Azerbaijão', value: 'AZ' },
    { label: 'Emirados Árabes Unidos', value: 'AE' },
    { label: 'Anguilla', value: 'AI' },
    { label: 'Antártida', value: 'AQ' },
    { label: 'Samoa Americana', value: 'AS' },
    { label: 'Aruba', value: 'AW' },
    { label: 'Alândia', value: 'AX' },
    { label: 'Bahamas', value: 'BS' },
    { label: 'Bahrein', value: 'BH' },
    { label: 'Bangladesh', value: 'BD' },
    { label: 'Barbados', value: 'BB' },
    { label: 'Barém', value: 'BH' },
    { label: 'Bélgica', value: 'BE' },
    { label: 'Belize', value: 'BZ' },
    { label: 'Benin', value: 'BJ' },
    { label: 'Bermudas', value: 'BM' },
    { label: 'Bielorússia', value: 'BY' },
    { label: 'São Bartolomeu', value: 'BL' },
    { label: 'Países Baixos Caribenhos', value: 'BQ' },
    { label: 'Ilha Bouvet', value: 'BV' },
    { label: 'Bolívia', value: 'BO' },
    { label: 'Bósnia e Herzegovina', value: 'BA' },
    { label: 'Botswana', value: 'BW' },
    { label: 'Brunei', value: 'BN' },
    { label: 'Bulgária', value: 'BG' },
    { label: 'Burkina Faso', value: 'BF' },
    { label: 'Burundi', value: 'BI' },
    { label: 'Butão', value: 'BT' },
    { label: 'Cabo Verde', value: 'CV' },
    { label: 'Camarões', value: 'CM' },
    { label: 'Canadá', value: 'CA' },
    { label: 'Cazaquistão', value: 'KZ' },
    { label: 'República Centro-Africana', value: 'CF' },
    { label: 'Chade', value: 'TD' },
    { label: 'Chile', value: 'CL' },
    { label: 'China', value: 'CN' },
    { label: 'Colômbia', value: 'CO' },
    { label: 'Comores', value: 'KM' },
    { label: 'Congo', value: 'CG' },
    { label: 'Costa do Marfim', value: 'CI' },
    { label: 'Costa Rica', value: 'CR' },
    { label: 'Croácia', value: 'HR' },
    { label: 'Cuba', value: 'CU' },
    { label: 'Chipre', value: 'CY' },
    { label: 'Ilhas Cocos (Keeling)', value: 'CC' },
    { label: 'República Democrática do Congo', value: 'CD' },
    { label: 'Ilhas Cook', value: 'CK' },
    { label: 'ilha da Curação', value: 'CW' },
    { label: 'Ilha do Natal', value: 'CX' },
    { label: 'Chéquia', value: 'CZ' },
    { label: 'Dinamarca', value: 'DK' },
    { label: 'Djibuti', value: 'DJ' },
    { label: 'Dominica', value: 'DM' },
    { label: 'República Dominicana', value: 'DO' },
    { label: 'Argélia', value: 'DZ' },
    { label: 'Egito', value: 'EG' },
    { label: 'El Salvador', value: 'SV' },
    { label: 'Equador', value: 'EC' },
    { label: 'Espanha', value: 'ES' },
    { label: 'Estados Unidos', value: 'US' },
    { label: 'Estônia', value: 'EE' },
    { label: 'Eswatini', value: 'SZ' },
    { label: 'Eslováquia', value: 'SK' },
    { label: 'Eslovênia', value: 'SI' },
    { label: 'Etiópia', value: 'ET' },
    { label: 'Saara Ocidental', value: 'EH' },
    { label: 'Eritreia', value: 'ER' },
    { label: 'Fiji', value: 'FJ' },
    { label: 'Filipinas', value: 'PH' },
    { label: 'Finlândia', value: 'FI' },
    { label: 'França', value: 'FR' },
    { label: 'Gâmbia', value: 'GM' },
    { label: 'Gana', value: 'GH' },
    { label: 'Geórgia', value: 'GE' },
    { label: 'Gibraltar', value: 'GI' },
    { label: 'Grécia', value: 'GR' },
    { label: 'Grenada', value: 'GD' },
    { label: 'Ilhas Malvinas', value: 'FK' },
    { label: 'Micronésia', value: 'FM' },
    { label: 'Ilhas Faroé', value: 'FO' },
    { label: 'Gabão', value: 'GA' },
    { label: 'Reino Unido', value: 'GB' },
    { label: 'Guiana Francesa', value: 'GF' },
    { label: 'Guernsey', value: 'GG' },
    { label: 'Gronelândia', value: 'GL' },
    { label: 'Guadalupe', value: 'GP' },
    { label: 'Ilhas Geórgia do Sul e Sandwich do Sul', value: 'GS' },
    { label: 'Guam', value: 'GU' },
    { label: 'Guatemala', value: 'GT' },
    { label: 'Guiné', value: 'GN' },
    { label: 'Guiné-Bissau', value: 'GW' },
    { label: 'Guiné Equatorial', value: 'GQ' },
    { label: 'Guyana', value: 'GY' },
    { label: 'Haiti', value: 'HT' },
    { label: 'Hong Kong', value: 'HK' },
    { label: 'Ilha Heard e Ilhas McDonald', value: 'HM' },
    { label: 'Holanda', value: 'NL' },
    { label: 'Honduras', value: 'HN' },
    { label: 'Hungria', value: 'HU' },
    { label: 'Iémen', value: 'YE' },
    { label: 'Ilhas Marshall', value: 'MH' },
    { label: 'Ilhas Maurício', value: 'MU' },
    { label: 'Ilhas Salomão', value: 'SB' },
    { label: 'Índia', value: 'IN' },
    { label: 'Indonésia', value: 'ID' },
    { label: 'Irã', value: 'IR' },
    { label: 'Iraque', value: 'IQ' },
    { label: 'Irlanda', value: 'IE' },
    { label: 'Islândia', value: 'IS' },
    { label: 'Israel', value: 'IL' },
    { label: 'Ilha de Man', value: 'IM' },
    { label: 'Território Britânico do Oceano Índico', value: 'IO' },
    { label: 'Itália', value: 'IT' },
    { label: 'Jersey', value: 'JE' },
    { label: 'Jamaica', value: 'JM' },
    { label: 'Japão', value: 'JP' },
    { label: 'Jordânia', value: 'JO' },
    { label: 'Kazakhstan', value: 'KZ' },
    { label: 'Quênia', value: 'KE' },
    { label: 'Kiribati', value: 'KI' },
    { label: 'Kuwait', value: 'KW' },
    { label: 'Quirguistão', value: 'KG' },
    { label: 'Camboja', value: 'KH' },
    { label: 'São Cristóvão e Nevis', value: 'KN' },
    { label: 'Coreia do Norte', value: 'KP' },
    { label: 'Coreia do Sul', value: 'KR' },
    { label: 'Ilhas Caimão', value: 'KY' },
    { label: 'Laos', value: 'LA' },
    { label: 'Líbano', value: 'LB' },
    { label: 'Libéria', value: 'LR' },
    { label: 'Líbia', value: 'LY' },
    { label: 'Liechtenstein', value: 'LI' },
    { label: 'Lituânia', value: 'LT' },
    { label: 'Lesoto', value: 'LS' },
    { label: 'Letónia', value: 'LV' },
    { label: 'Luxemburgo', value: 'LU' },
    { label: 'Madagáscar', value: 'MG' },
    { label: 'Malásia', value: 'MY' },
    { label: 'Malawi', value: 'MW' },
    { label: 'Maldivas', value: 'MV' },
    { label: 'Marrocos', value: 'MA' },
    { label: 'Mauritânia', value: 'MR' },
    { label: 'México', value: 'MX' },
    { label: 'Mianmar', value: 'MM' },
    { label: 'Moçambique', value: 'MZ' },
    { label: 'Moldávia', value: 'MD' },
    { label: 'São Martinho', value: 'MF' },
    { label: 'Macedónia do Norte', value: 'MK' },
    { label: 'Mali', value: 'ML' },
    { label: 'Mongólia', value: 'MN' },
    { label: 'Macau', value: 'MO' },
    { label: 'Marianas Setentrionais', value: 'MP' },
    { label: 'Martinica', value: 'MQ' },
    { label: 'Montserrat', value: 'MS' },
    { label: 'Malta', value: 'MT' },
    { label: 'Mônaco', value: 'MC' },
    { label: 'Montenegro', value: 'ME' },
    { label: 'Namíbia', value: 'NA' },
    { label: 'Nauru', value: 'NR' },
    { label: 'Nepal', value: 'NP' },
    { label: 'Nicarágua', value: 'NI' },
    { label: 'Níger', value: 'NE' },
    { label: 'Nigéria', value: 'NG' },
    { label: 'Noruega', value: 'NO' },
    { label: 'Nova Zelândia', value: 'NZ' },
    { label: 'Nova Caledónia', value: 'NC' },
    { label: 'Ilha Norfolk', value: 'NF' },
    { label: 'Niue', value: 'NU' },
    { label: 'Omã', value: 'OM' },
    { label: 'Países Baixos', value: 'NL' },
    { label: 'Palau', value: 'PW' },
    { label: 'Panamá', value: 'PA' },
    { label: 'Papua-Nova Guiné', value: 'PG' },
    { label: 'Polinésia Francesa', value: 'PF' },
    { label: 'Saint-Pierre e Miquelon', value: 'PM' },
    { label: 'Ilhas Pitcairn', value: 'PN' },
    { label: 'Paquistão', value: 'PK' },
    { label: 'Porto Rico', value: 'PR' },
    { label: 'Palestina', value: 'PS' },
    { label: 'Paraguai', value: 'PY' },
    { label: 'Peru', value: 'PE' },
    { label: 'Polônia', value: 'PL' },
    { label: 'Portugal', value: 'PT' },
    { label: 'Qatar', value: 'QA' },
    { label: 'Romênia', value: 'RO' },
    { label: 'Ruanda', value: 'RW' },
    { label: 'Reunião', value: 'RE' },
    { label: 'Sudão', value: 'SD' },
    { label: 'Santa Helena, Ascensão e Tristão da Cunha', value: 'SH' },
    { label: 'Rússia', value: 'RU' },
    { label: 'San Marino', value: 'SM' },
    { label: 'Santa Lúcia', value: 'LC' },
    { label: 'São Tomé e Príncipe', value: 'ST' },
    { label: 'São Vicente e Granadinas', value: 'VC' },
    { label: 'Senegal', value: 'SN' },
    { label: 'Serbia', value: 'RS' },
    { label: 'Seychelles', value: 'SC' },
    { label: 'Singapura', value: 'SG' },
    { label: 'Ilhas Svalbard e Jan Mayen', value: 'SJ' },
    { label: 'Serra Leoa', value: 'SL' },
    { label: 'Sudão do Sul', value: 'SS' },
    { label: 'São Martinho', value: 'SX' },
    { label: 'Síria', value: 'SY' },
    { label: 'Somália', value: 'SO' },
    { label: 'Sri Lanka', value: 'LK' },
    { label: 'Suécia', value: 'SE' },
    { label: 'Suíça', value: 'CH' },
    { label: 'Suriname', value: 'SR' },
    { label: 'Tailândia', value: 'TH' },
    { label: 'Taiwan', value: 'TW' },
    { label: 'Tanzânia', value: 'TZ' },
    { label: 'Timor-Leste', value: 'TL' },
    { label: 'Ilhas Turks e Caicos', value: 'TC' },
    { label: 'Terras Austrais e Antárticas Francesas', value: 'TF' },
    { label: 'Tajiquistão', value: 'TJ' },
    { label: 'Tokelau', value: 'TK' },
    { label: 'Togo', value: 'TG' },
    { label: 'Tonga', value: 'TO' },
    { label: 'Trinidad e Tobago', value: 'TT' },
    { label: 'Tunísia', value: 'TN' },
    { label: 'Turcomenistão', value: 'TM' },
    { label: 'Turquia', value: 'TR' },
    { label: 'Tuvalu', value: 'TV' },
    { label: 'Ucrânia', value: 'UA' },
    { label: 'Uganda', value: 'UG' },
    { label: 'Uruguai', value: 'UY' },
    { label: 'Ilhas Menores Distantes dos Estados Unidos', value: 'UM' },
    { label: 'Uzbequistão', value: 'UZ' },
    { label: 'Vaticano', value: 'VA' },
    { label: 'Venezuela', value: 'VE' },
    { label: 'Ilhas Virgens', value: 'VG' },
    { label: 'Ilhas Virgens dos Estados Unidos', value: 'VI' },
    { label: 'Vietnã', value: 'VN' },
    { label: 'Vanuatu', value: 'VU' },
    { label: 'Wallis e Futuna', value: 'WF' },
    { label: 'Samoa', value: 'WS' },
    { label: 'Kosovo', value: 'XK' },
    { label: 'Mayotte', value: 'YT' },
    { label: 'Zâmbia', value: 'ZM' },
    { label: 'Zimbábue', value: 'ZW' }
  ];

  constructor() { }

  getCountries(): { label: string, value: string }[] {
    return this.countries;
  }

  getPaises(): Observable<{ label: string, value: string }[]> {
    return of(this.countries);
  }

}